import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

var title = 'UTM - '
const routes = [
  {
    path: '/',
    redirect: "/ingreso",
  },
  {
    path: '/ingreso',
    name: 'ingreso',
    component: () => import('../views/Ingreso.vue'),
    meta: {
      title: title + "Consulta de resultados",
    },
  },
  {
    path: '/admin',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: "/",
        name: "admin",
        component: () => import('../views/Configuracion.vue'),
        meta: {
          requiresAuth: true,
          title: title + "Configuración",
        },
      }
    ]
  },
  {
    path: '/resultados',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: "/",
        name: "resultados",
        component: () => import('../views/Resultados.vue'),
        meta: {
          requiresAuth: true,
          title: title + "Resultados",
        },
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const currentUser = sessionStorage.auth
    ? JSON.parse(atob(sessionStorage.auth))
    : null;
  const id = currentUser ? currentUser.ID.trim() : ''

  document.title = to.meta.title;
  if (requiresAuth && !currentUser) next("ingreso");
  else if (((currentUser && parseInt(id) == 99 && !requiresAuth)) || (currentUser && parseInt(id) == 99 && to.path.indexOf("admin") == -1)) next("admin");
  else if (((currentUser && parseInt(id) != 99 && !requiresAuth)) || (currentUser && parseInt(id) != 99 && to.path.indexOf("resultados") == -1)) next("resultados");
  else next()
})
export default router
